<template>
    <AppLayout>
        <div class="home" style="margin-top: 110px !important;">
            <section id="settings-categories">
                <div class="container">
                <div class="panel">
                    <label for="" class="font-bold">1. Departments</label>
                    <div class="row mt-2">
                        <div class="col-md-2">
                            <input type="text" class="form-control" placeholder="Enter department" v-model="department">
                        </div>

                        <div class="col-md-2">
                            <input type="number" class="form-control" placeholder="Levels of Ranks" v-model.number="ranks" max="2" min="1">
                        </div>

                        <div class="col-md-6">
                            <button class="btn btn-primary btn-small" @click="postDeparment">Add</button>
                        </div>
                        <div class="col-md-2">
                            <button class="btn-small btn btn-default" :style="{ 'display': departmentDisplay === 'block' ? 'none' : 'block' }" style="border: 1px solid gray; float: right;" @click="showList">View List</button>
                        </div>
                </div>

                <div v-show="departmentDisplay === 'block'" class="row mt-4" style="margin-left: 3px; margin-right: 3px">
                    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
                        <h6 class="mb-0" style="padding:0px !important">Departments</h6>
                    </div>
                    <SkeletonLoader v-if="loading" type="table" :rows="6" :columns="5" />
                    <table
                        v-else
                        id="departmentsTable"
                        ref="departmentsTable"
                        class="table table-sm table-hover mb-0"
                        @click="onTableClick"
                    >
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Department</th>
                                <th>Hierarchies</th>
                                <th>Roles</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dept, index) in departmentsList" :key="dept.id" :data-id="dept.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ dept.name }}</td>
                                <td>{{ dept.ranks }}</td>
                                <td>{{ formatRoles(dept) }}</td>
                                <td>
                                    <button type="button" class="btn-sm btn btn-danger" data-action="delete">Delete</button>
                                </td>
                            </tr>
                            <tr v-if="departmentsList.length === 0">
                                <td colspan="5" class="text-center text-muted">No departments found. Add one above.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
    </div>

    </div>

    </section>
    </div>
</AppLayout>
</template>


<script>
import $ from 'jquery'
import 'datatables.net-vue3'
import 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
import 'datatables.net-responsive-bs5'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.print.js'
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
    name: 'SettingsCategoryPage',
    components: { SkeletonLoader },
    data: () => ({
        token: null,
        department: "",
        ranks: 1,
        departmentDisplay: "block",
        dataTable: null,
        loading: false,
    }),
    computed: {
        ...mapGetters(["getDepartments"]),
        departments() {
            return this.getDepartments || []
        },
        departmentsList() {
            return Array.isArray(this.departments) ? this.departments : []
        },
    },
    watch: {
        ranks(value) {
            if (value > 2) this.ranks = 2
            if (value < 1) this.ranks = 1
        },
        departmentsList: {
            handler() {
                this.$nextTick(() => this.reinitDataTable())
            },
            deep: true,
        },
    },
    mounted() {
        try {
            this.token = JSON.parse(localStorage.getItem('access_token'))
        } catch (e) {
            this.token = null
        }
        this.showList()
    },
    beforeUnmount() {
        this.destroyDataTable()
    },
    methods: {
        ...mapActions(['fetchDepartments']),
        formatRoles(dept) {
            const perms = dept.permissions || []
            return perms.map(p => p.name).filter(Boolean).join(', ') || '-'
        },
        onTableClick(e) {
            const btn = e.target.closest('[data-action="delete"]')
            if (btn) {
                const row = btn.closest('tr')
                const id = row && row.dataset.id ? parseInt(row.dataset.id, 10) : null
                if (id) this.deleteDepartment(id)
            }
        },
        showList() {
            this.departmentDisplay = 'block'
            this.loadDepartments()
        },
        async loadDepartments() {
            this.loading = true
            try {
                await this.fetchDepartments()
            } catch (e) {
                console.error('Failed to fetch departments', e)
            } finally {
                this.loading = false
            }
        },
        reinitDataTable() {
            this.destroyDataTable()
            this.$nextTick(() => {
                setTimeout(() => this.initializeDataTable(), 50)
            })
        },
        initializeDataTable() {
            try {
                const el = this.$refs.departmentsTable
                if (!el || this.departmentsList.length === 0) return
                if ($.fn.DataTable.isDataTable(el)) return
                this.dataTable = $(el).DataTable({
                    dom: 'Bfrtip',
                    responsive: true,
                    pageLength: 25,
                    language: {
                      paginate: {
                        previous: '<i class="fas fa-chevron-left"></i>',
                        next: '<i class="fas fa-chevron-right"></i>',
                      },
                    },
                    order: [[1, 'asc']],
                    buttons: [
                        'colvis',
                        'pageLength',
                        { extend: 'csv', text: 'Export CSV', className: 'btn btn-primary btn-sm' },
                        { extend: 'excel', text: 'Export Excel', className: 'btn btn-primary btn-sm' },
                        { extend: 'print', text: 'Print', className: 'btn btn-secondary btn-sm' },
                    ],
                })
            } catch (err) {
                console.warn('DataTable init failed', err)
            }
        },
        destroyDataTable() {
            try {
                const el = this.$refs.departmentsTable
                if (el && this.dataTable && $.fn.DataTable.isDataTable(el)) {
                    this.dataTable.destroy()
                    this.dataTable = null
                }
            } catch (e) {
                console.warn('DataTable destroy failed', e)
            }
        },
        async postDeparment() {
            if (!this.department || !this.department.trim()) {
                Swal.fire({ icon: 'warning', title: 'Required', text: 'Please enter a department name.' })
                return
            }
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + this.token },
                body: JSON.stringify({ name: this.department.trim(), ranks: this.ranks })
            }
            const res = await fetch(process.env.VUE_APP_URL + '/departments', requestOptions)
            const data = await res.json()
            if (data.status === true) {
                this.departmentDisplay = 'block'
                this.department = ""
                await this.fetchDepartments()
                Swal.fire({ icon: 'success', title: 'Department added', text: 'Department created successfully.' })
            } else {
                Swal.fire({ icon: 'error', title: 'Department not added', text: data.message || 'Failed to add department' })
            }
        },
        async deleteDepartment(id) {
            const result = await Swal.fire({
                icon: 'warning',
                title: 'Delete Department?',
                text: 'This action cannot be undone.',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Delete',
            })
            if (!result.isConfirmed) return

            const requestOptions = {
                method: "GET",
                headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token },
            }
            const res = await fetch(process.env.VUE_APP_URL + '/departments/delete/' + id, requestOptions)
            const data = await res.json()
            if (data.status === true) {
                Swal.fire({ icon: 'success', title: 'Deleted', text: 'Department deleted successfully.' })
                await this.fetchDepartments()
            } else {
                Swal.fire({ icon: 'error', title: 'Delete failed', text: data.message || 'Failed to delete department' })
            }
        },
    },
}
</script>


<style lang="scss" scoped>
ul {
    display: block;
    list-style-type: none;
}
ul > li {
    color: #0c275e;
    list-style: none;
    display: block;
    padding: 3px 0px;
}
ul li:hover {
    color: #00005C;
    cursor: pointer;
    text-decoration: underline;
}

#main-header {
    padding: 10px;
    background-color: #dce2f0;
}
</style>
